import { ID } from '@griply/types';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useUpcomingListCustomOrder = (): Record<ID, ID[]> => {
  const user = useUser();

  return useMemo(
    () => user?.settings?.todoSorting ?? {},
    [user?.settings?.todoSorting],
  );
};
